import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { UI_BOTTOM_COMPONENTS } from '~/constants/variables';
import { useGlobal } from '~/hooks/useGlobal';

import { ALERT_DURATION } from '../../stores/constants';
import { mainStore } from '../../stores/MainStore';

export default observer(() => {
  const { isSSR, isMobile } = useGlobal();
  const [bottomOffset, setBottomOffset] = useState(10);

  const handleDismiss = () => {
    const alert = mainStore.popAlert();
    if (alert && alert.onDismiss) {
      alert.onDismiss();
    }
  };

  useEffect(() => {
    if (!mainStore.alerts.length) {
      return;
    }
    const timeout = setTimeout(() => {
      mainStore.popAlert();
    }, ALERT_DURATION);
    return () => clearTimeout(timeout);
  });

  const updateOffset = () => {
    let totalOffset = 10;

    const tryUpdate = () => {
      const navbar = document.querySelector(`#${UI_BOTTOM_COMPONENTS.NAVBAR}`);
      const cta = document.querySelector(`#${UI_BOTTOM_COMPONENTS.CTA}`);

      if (navbar) {
        totalOffset += navbar.getBoundingClientRect().height;
      }
      if (cta) {
        totalOffset += cta.getBoundingClientRect().height;
      }

      const cssOffset = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
          '--offset-bottom',
        ) || '0',
        10,
      );

      totalOffset += cssOffset;
      setBottomOffset(totalOffset);
    };

    tryUpdate();
  };

  useEffect(() => {
    if (!isMobile) {
      return;
    }

    const observer = new MutationObserver(() => {
      requestAnimationFrame(updateOffset);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
    });

    window.addEventListener('resize', updateOffset);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', updateOffset);
    };
  }, [isMobile]);

  if (!mainStore.alerts.length || isSSR) {
    return null;
  }

  return createPortal(
    <>
      {mainStore.alerts.slice(-1).map((item) => (
        <div
          className={classes([`alert _fixed _${item.type}`, item.className])}
          key={item.id}
          onClick={handleDismiss}
          dangerouslySetInnerHTML={{ __html: item.message }}
          style={isMobile ? { bottom: `${bottomOffset}px` } : {}}
        />
      ))}
    </>,
    document.body,
  );
});
